import featureNames, { FeatureType } from '../defs/features';
import {
  ConsentSaveType, ConsentType, FeatureItemSaveType, FeatureItemType,
} from '../types/common';

function* getFeaturesIterator(consent: ConsentType) {
  let i = 0;
  for (; i < featureNames.length; i += 1) {
    if (consent[featureNames[i]]) {
      yield* consent[featureNames[i]];
    }
  }
}

const consentHasAtLeastOneNotGrantedFeature = (consent: ConsentType) => {
  let ret = false;
  // eslint-disable-next-line no-restricted-syntax
  for (const { granted } of getFeaturesIterator(consent)) {
    if (!granted) {
      ret = true;
      break;
    }
  }
  return ret;
};

export function haveUncheckedFeatures(consents: ConsentType[]) {
  return !!consents.find(consentHasAtLeastOneNotGrantedFeature);
}

export const mapConsentFeaturesTo = <T>(
  consent: ConsentType | ConsentSaveType,
  callback: (feature: FeatureItemType | FeatureItemSaveType, featureName: FeatureType) => T,
) => {
  const ret: Partial<Record<FeatureType, T[]>> = {};

  featureNames.forEach((featureName) => {
    if (!consent[featureName]) {
      return;
    }

    ret[featureName] = consent[featureName].map((feature) => callback(feature, featureName));
  });

  return ret;
};

export const getAllFeatures = (consent: ConsentType) => Array.from(getFeaturesIterator(consent));

export default haveUncheckedFeatures;
